// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
    apiKey: "AIzaSyCM3-jYbrZx-rfBOnN_K1Ylsb4tBt_vmUI",
    authDomain: "nuralapp.firebaseapp.com",
    databaseURL: "https://nuralapp-default-rtdb.firebaseio.com",
    projectId: "nuralapp",
    storageBucket: "nuralapp.appspot.com",
    messagingSenderId: "70460866959",
    appId: "1:70460866959:web:c4c7e20d9a606400824bfa",
    measurementId: "G-8816C9W5YL"
  };
  
  // Initialize Firebase
  export const app = initializeApp(firebaseConfig);
  export const db = getFirestore(app)

